import { BrowserModule } from "@angular/platform-browser";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AppComponent } from "./app.component";
import { AuthGuard } from "./+core/guards/auth.guard";
import {
  AuthenticationService,
  SharedModule,
  MainService,
  DataService,
  ItemSearchComponent,
  VchrprintComponent,
  GridEditComponent,
  InTransactionsService,
  InReportService,
  InPurchasesService,
  InSalesService,
  InposService,
  RestItemService,
  InProductsService,
  SupplierSearchComponent,
  UserroleSearchComponent,
  CaMasterService,
  RestMasterService,
  CaTransService

} from "./shared";
import { HttpModule } from "@angular/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClient, HttpClientModule } from '@angular/common/http'
import { ExcelService } from "./shared/services/inventory/excel.service";
import { AppConfigService } from "./shared/services/app-config.service";
import { InToolsService } from "./shared/services/inventory/in-tools.service";
import { LoyaltyService } from "./shared/services/Loyalty/loyalty.service";
import { CaMasterModule } from "./lazy-modules/+private-page/accounts/ca-master/ca-master.module";
import { DatePipe } from '@angular/common'
import { ToolsService } from './shared/services/tools/tools.service';
import { OrderIntegrationService } from './shared/services/orderIntegration/orderIntegration.service';
import { ApprovalService } from './shared/services/tools/approval.service';
const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full"
  },
  {
    path: "login",
    loadChildren: "./lazy-modules/public-pages/+login/login.module#LoginModule"
  },
  {
    path: "app",
    loadChildren:
      "./lazy-modules/+app/select-company/select-company.module#SelectCompanyModule"
  },
  { path: "**", redirectTo: "app" }
];
const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes),
    SharedModule,
    HttpModule,
    BrowserAnimationsModule,
    HttpClientModule
  ],
  providers: [AppConfigService, DatePipe, {
    provide: APP_INITIALIZER,
    useFactory: appInitializerFn,
    multi: true,
    deps: [AppConfigService]
  },
    AuthenticationService,
    AuthGuard,
    MainService,
    DataService,
    InTransactionsService,
    InReportService,
    InSalesService,
    InposService,
    RestItemService,
    InProductsService,
    ExcelService,
    InToolsService,
    LoyaltyService,
    CaMasterService,
    InPurchasesService,
    RestMasterService,
    ToolsService,
    OrderIntegrationService,
    ApprovalService,
    CaTransService
  ],
  bootstrap: [AppComponent],
  entryComponents: [ItemSearchComponent, GridEditComponent, VchrprintComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/app.module.ts